import { ContextMenuState } from "@app/utils/hooks/useContextMenu";

import Menu, { MenuProps } from "@rui/Menu";
import MenuItem from "@rui/MenuItem";

interface IReportRowContextMenu extends MenuProps {
  handleOpenNewTabClick: (e: React.MouseEvent<HTMLElement>) => void;
  contextMenuState: ContextMenuState;
  handleContextMenuClose: () => void;
}

const ReportRowContextMenu = ({
  handleOpenNewTabClick,
  contextMenuState,
  handleContextMenuClose,
  ...props
}: Omit<IReportRowContextMenu, "open">) => (
  <Menu
    {...props}
    // Disabling scroll lock as the scroll lock does not work
    // on the meeting reports table and it causes a layoutshift when browser window has a scrollbar gutter
    disableScrollLock
    open={contextMenuState !== null}
    onClose={handleContextMenuClose}
    anchorReference="anchorPosition"
    anchorPosition={
      contextMenuState !== null
        ? { top: contextMenuState.mouseY, left: contextMenuState.mouseX }
        : undefined
    }
  >
    <MenuItem onClick={handleOpenNewTabClick} autoFocus={false}>
      Open in new tab
    </MenuItem>
  </Menu>
);

export default ReportRowContextMenu;
